import React, { useContext } from 'react'
import { useRouter } from 'next/router'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import DEFAULT_META_TAGS from '../../constants/meta'
import Template, { LinkTag } from './Template'

const Meta = () => {
  const { insideTrackTitle, referral, prePopData } =
    useContext(BootstrapDataContext)
  const router = useRouter()
  const { pathname = '/vacationpackages' } = router
  const { image, url, description, title } = DEFAULT_META_TAGS
  const cityName = prePopData?.hotels?.endLocation?.cityName
  const isSEMCampaign = referral?.clickId?.includes('hotel') && cityName
  const pricelineTitle = isSEMCampaign
    ? `The Best Deals on ${cityName} Hotels at Priceline.com`
    : title[pathname as keyof typeof title]
  const isHotelsLP = ['/hotels', '/hotels/'].includes(pathname)
  const isFlightLP = ['/flights', '/flights/'].includes(pathname)
  const isVIPLP = ['/vip', '/vip/'].includes(pathname)
  const isHomepageLP = ['/'].includes(pathname)

  let metaDescription = description.vacationpackages
  if (isFlightLP) {
    metaDescription = description.flights
  } else if (isHotelsLP) {
    metaDescription = description.hotels
  } else if (isVIPLP) {
    metaDescription = description.vip
  } else if (isHomepageLP) {
    metaDescription = description.homepage
  }

  const favicons: LinkTag[] = [
    {
      rel: 'shortcut icon',
      href: '/favicon.ico',
      type: 'image/x-icon'
    }
  ]

  const additionalLinks: LinkTag[] = [
    {
      rel: 'alternate',
      href: 'android-app://com.priceline.android.negotiator/pclnnegotiator/home'
    }
  ]

  return (
    <Template
      additionalLinks={additionalLinks}
      brandUrl={url}
      description={metaDescription}
      favicons={favicons}
      imageUrl={image}
      title={insideTrackTitle || pricelineTitle}
      twitterHandle="@priceline"
    />
  )
}

export default Meta
